import axios from "axios";

// Register
export const registerUser = async (data) => {
  const res = await axios.post("https://6a01c8ee36fb6ad04de1b13c.mockapi.io/reactfood/user/", data);
  return res;                  
};

// login
export const loginUser = async (data) => {
  const res = await axios.get(
        `https://6a01c8ee36fb6ad04de1b13c.mockapi.io/reactfood/users?email=${data.email}&password=${data.password}`
  );

  if (res.data.length === 0) {
    throw new Error("Invalid credentials");
  }

  return res;
};